var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L10 10L1 19","stroke":"#FF5F00"}));
}

ChevronRight.defaultProps = {"width":"11","height":"20","viewBox":"0 0 11 20","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
